// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_format from "rescript/lib/es6/caml_format.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";

function RangeSlider(props) {
  var onChange = props.onChange;
  var emptyColor = props.emptyColor;
  var fillColor = props.fillColor;
  var value = props.value;
  var max = props.max;
  var min = props.min;
  var min$1 = min !== undefined ? min : 0;
  var max$1 = max !== undefined ? max : 100;
  var value$1 = value !== undefined ? value : 10;
  var fillColor$1 = fillColor !== undefined ? fillColor : Css.hex(SterlingTokens$LiveRoom.Colors.primaryGold60_nohashtag);
  var emptyColor$1 = emptyColor !== undefined ? emptyColor : Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag);
  var match = React.useState(function () {
        return Css.linearGradient(Css.deg(90), [
                    [
                      Css.pct(0),
                      fillColor$1
                    ],
                    [
                      Css.pct(value$1),
                      fillColor$1
                    ],
                    [
                      Css.pct(value$1),
                      emptyColor$1
                    ],
                    [
                      Css.pct(100),
                      emptyColor$1
                    ]
                  ]);
      });
  var setGradient = match[1];
  return React.createElement("input", {
              className: Curry._1(Css.style, {
                    hd: Css.width(Css.px(80)),
                    tl: {
                      hd: Css.height(Css.px(10)),
                      tl: {
                        hd: Css.unsafe("-webkitAppearance", "none"),
                        tl: {
                          hd: Css.outlineStyle(Css.none),
                          tl: {
                            hd: Css.background(match[0]),
                            tl: {
                              hd: Css.borderRadius(Css.px(8)),
                              tl: {
                                hd: Css.height(Css.px(4)),
                                tl: {
                                  hd: Css.width(Css.px(94)),
                                  tl: {
                                    hd: Css.selector("::-webkit-slider-thumb", {
                                          hd: Css.unsafe("-webkitAppearance", "none"),
                                          tl: {
                                            hd: Css.width(Css.px(10)),
                                            tl: {
                                              hd: Css.height(Css.px(10)),
                                              tl: {
                                                hd: Css.backgroundColor(fillColor$1),
                                                tl: {
                                                  hd: Css.borderRadius(Css.pct(50)),
                                                  tl: /* [] */0
                                                }
                                              }
                                            }
                                          }
                                        }),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }),
              max: String(max$1),
              min: String(min$1),
              type: "range",
              value: String(value$1),
              onChange: (function ($$event) {
                  var tmp;
                  try {
                    tmp = Caml_format.int_of_string($$event.target.value);
                  }
                  catch (raw_exn){
                    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                    if (exn.RE_EXN_ID === "Failure") {
                      tmp = 0;
                    } else {
                      throw exn;
                    }
                  }
                  Curry._1(onChange, tmp);
                }),
              onInput: (function ($$event) {
                  var newValue;
                  try {
                    newValue = Caml_format.int_of_string($$event.target.value);
                  }
                  catch (raw_exn){
                    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                    if (exn.RE_EXN_ID === "Failure") {
                      newValue = 0;
                    } else {
                      throw exn;
                    }
                  }
                  Curry._1(setGradient, (function (param) {
                          return Css.linearGradient(Css.deg(90), [
                                      [
                                        Css.pct(0),
                                        fillColor$1
                                      ],
                                      [
                                        Css.pct(newValue),
                                        fillColor$1
                                      ],
                                      [
                                        Css.pct(newValue),
                                        emptyColor$1
                                      ],
                                      [
                                        Css.pct(100),
                                        emptyColor$1
                                      ]
                                    ]);
                        }));
                })
            });
}

var make = RangeSlider;

export {
  make ,
}
/* Css Not a pure module */
